(function () {
  "use strict";

  var root = document.getElementById("juici-order-complete");
  if (!root) return;

  var messageEl = document.getElementById("juici-order-complete-message");
  var refEl = document.getElementById("juici-order-complete-ref");
  var timeEl = document.getElementById("juici-order-complete-time");
  var apiBase = (root.dataset.apiBase || "https://juici-checkout.vercel.app").replace(
    /\/$/,
    ""
  );

  var params = new URLSearchParams(window.location.search);
  var reference =
    params.get("ref") ||
    params.get("customReference") ||
    params.get("custom_reference") ||
    params.get("client_reference") ||
    "";

  function setMessage(text) {
    if (messageEl) messageEl.textContent = text;
  }

  function showConfirmedTime(shipping) {
    if (!timeEl || !shipping) return;

    var fulfillment = shipping.fulfillment_type;
    var label = shipping.pickup_label || "";

    if (fulfillment === "delivery") {
      timeEl.hidden = false;
      timeEl.textContent = "Fulfillment: Local Barbados Delivery";
      return;
    }

    if (label) {
      timeEl.hidden = false;
      timeEl.textContent = "Confirmed pickup: " + label;
      return;
    }

    if (shipping.pickup_date || shipping.pickup_time) {
      var parts = [];
      if (shipping.pickup_date) parts.push(shipping.pickup_date);
      if (shipping.pickup_time) parts.push(shipping.pickup_time);
      timeEl.hidden = false;
      timeEl.textContent = "Confirmed pickup: " + parts.join(" · ");
    }
  }

  function clearCart() {
    return fetch("/cart/clear.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart clear failed");
        return res.json().catch(function () {
          return { item_count: 0 };
        });
      })
      .then(function (cart) {
        // Notify theme cart drawers / bubbles that listen for cart updates.
        try {
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", { detail: cart })
          );
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", { detail: cart })
          );
        } catch (_) {
          /* ignore */
        }
        return cart;
      })
      .catch(function () {
        // Retry once — some themes race cart cookie writes.
        return fetch("/cart/clear.js", {
          method: "POST",
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        }).catch(function () {
          return null;
        });
      });
  }

  function pollStatus(attempt) {
    if (!reference) return;

    fetch(
      apiBase +
        "/api/payment-status?reference=" +
        encodeURIComponent(reference)
    )
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          if (attempt < 15) {
            window.setTimeout(function () {
              pollStatus(attempt + 1);
            }, 2000);
          }
          return;
        }

        var data = result.data;
        if (data.shipping) {
          showConfirmedTime(data.shipping);
        }

        if (data.shopify_order_id) {
          setMessage(
            "Your Shopify order is confirmed. A receipt will be emailed shortly."
          );
          return;
        }

        if (data.status === "paid") {
          setMessage("Payment confirmed. Creating your Shopify order…");
        } else if (data.status === "pending") {
          setMessage("Waiting for payment confirmation…");
        } else if (data.status === "processed") {
          setMessage("Your order is confirmed.");
          return;
        }

        if (attempt < 15) {
          window.setTimeout(function () {
            pollStatus(attempt + 1);
          }, 2000);
        } else {
          setMessage(
            "Payment received. If you do not see an order confirmation soon, contact support with your reference."
          );
        }
      })
      .catch(function () {
        if (attempt < 15) {
          window.setTimeout(function () {
            pollStatus(attempt + 1);
          }, 2000);
        }
      });
  }

  // Always clear cart when landing here after Fygaro payment.
  clearCart().then(function () {
    setMessage(
      "Your cart has been cleared. Confirming your Shopify order…"
    );
  });

  if (reference && refEl) {
    refEl.hidden = false;
    refEl.textContent = "Reference: " + reference;
  }

  pollStatus(0);
})();
